import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  //...
  apiKey: 'AIzaSyC1zoTWs101kJLVNdJPigSLhjQd2ip3WWE',
  authDomain: 'phone-auth-c96e3.firebaseapp.com',
  projectId: 'phone-auth-c96e3',
  storageBucket: 'phone-auth-c96e3.appspot.com',
  messagingSenderId: '389833888256',
  appId: '1:389833888256:web:9289f5e3501b7898763ee5',
};

const app = initializeApp(firebaseConfig);

export const authentication = getAuth(app);
